import {injectable} from "inversify";
import {IApiResponse, IHttpService} from "../http-service";
import {rootContainer, TYPE} from "../container/root";

export interface IDevBillingSettingDto {
    current_day_for_billing?: string;
    _deleted?: boolean;
}

@injectable()
class DevSettingsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async fetchDevBillingSettings(): Promise<IDevBillingSettingDto> {
        const res = await this.httpService.get<IApiResponse<IDevBillingSettingDto>>(`/rms-api/dev-billing-settings`);
        return res.payload;
    }

    async updateBillingDevSettings(data: IDevBillingSettingDto): Promise<IDevBillingSettingDto> {
        const res = await this.httpService.post<IApiResponse<IDevBillingSettingDto>>(`/rms-api/dev-billing-settings`, data);
        return res.payload;
    }

    async runBillingCalculation(billingCalculationDate: string): Promise<void> {
        await this.httpService.post(`/rms-api/run-billing-calculation`, { billingCalculationDate });
    }

}

export default DevSettingsService;